import './components/calculators/format';
import './components/calculators/finance';
import './components/calculators/calculator-products';
import './components/calculators/mortgage';
import './components/calculators/input';
import './components/calculators/products';

// =====================================================================
//  CONVENTIONAL PERSONAL LOAN — interactivity layer
//  Static markup lives in conventional-personal-loan.php.
// =====================================================================
(function () {
  const fmt = Calc.format;
  const fin = Calc.finance;

  const REF_AMOUNTS = [5000, 10000, 20000, 30000, 50000, 75000, 100000,
                       150000, 200000, 250000];
  const REF_TENURES = [2, 3, 4, 5, 6, 7];

  const state = {
    amount: 50000,
    interestRate: 0.0507,
    tenure: 7,
    method: 'flat',
    activeTab: 'breakdown',
    sort: { key: 'best', dir: 'asc' },    // template's selected option sets the default
  };

  const setText = (id, val) => {
    const el = document.getElementById(id);
    if (el) el.textContent = val;
  };
  // Write a value into a placeholder span (text is in HTML, JS only writes the value).
  const setVal = (sel, val) => {
    const el = document.querySelector(sel);
    if (el) el.textContent = val;
  };
  // Show one sibling at a time inside a parent — text variants live in HTML.
  const toggle = (sel, hide) => {
    const el = document.querySelector(sel);
    if (el) el.classList.toggle('d-none', hide);
  };
  const syncInput = (id, val) => Calc.input.syncValue(id, val);
  // Escape dynamic strings before injecting as HTML (bank names / reason text
  // originate from the external product feed).
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));

  function computeCalc() {
    return state.method === 'flat'
      ? fin.flatRate(state.amount, state.interestRate, state.tenure)
      : fin.reducingRate(state.amount, state.interestRate, state.tenure);
  }

  function updateStatBand() {
    const calc = computeCalc();
    const eq = state.method === 'flat'
      ? fin.solveEffectiveRate(state.amount, calc.monthlyInstalment, state.tenure)
      : state.interestRate;
    setText('cp-stat-monthly',    fmt.money(calc.monthlyInstalment, 0));
    toggle('.cp-stat-rate-label-eff', state.method !== 'flat');
    toggle('.cp-stat-rate-label-int', state.method === 'flat');
    setText('cp-stat-rate',       fmt.percent(eq));
    setText('cp-stat-interest',   fmt.money(calc.totalInterest, 0));
    setText('cp-stat-total',      fmt.money(calc.totalRepayment, 0));
  }

  function updateBreakdown() {
    const calc = computeCalc();
    let eqEffective, eqFlat, spread;
    if (state.method === 'flat') {
      eqEffective = fin.solveEffectiveRate(state.amount, calc.monthlyInstalment, state.tenure);
      eqFlat = state.interestRate;
      spread = fin.effectiveToSBRSpread(eqEffective, 0.03);
    } else {
      eqEffective = state.interestRate;
      eqFlat = fin.solveFlatEquivalent(state.amount, state.interestRate, state.tenure);
      spread = fin.effectiveToSBRSpread(eqEffective, 0.03);
    }

    setText('cp-r-amount',   fmt.money(state.amount));
    setVal('.cp-r-tenure-y', state.tenure);
    setVal('.cp-r-tenure-m', state.tenure * 12);
    setVal('.cp-r-flat-num', fmt.percent(eqFlat));
    setVal('.cp-r-eff-num',  fmt.percent(eqEffective));
    setVal('.cp-r-sbr-num',  fmt.percent(spread));
    setText('cp-r-interest', fmt.money(calc.totalInterest));
    setText('cp-r-total',    fmt.money(calc.totalRepayment));
    setText('cp-r-monthly',  fmt.money(calc.monthlyInstalment));

    // Toggle the variant labels (text variants live in HTML).
    const isFlat = state.method === 'flat';
    toggle('.cp-r-flat-your',  !isFlat);
    toggle('.cp-r-flat-equiv',  isFlat);
    toggle('.cp-r-eff-bnm',     isFlat);   // BNM disclosure shown when user input is flat
    toggle('.cp-r-eff-your',   !isFlat);   // (your input) shown when user input is reducing
    const flatRow = document.getElementById('cp-r-flat-row');
    const effRow  = document.getElementById('cp-r-eff-row');
    if (flatRow) flatRow.classList.toggle('highlight', isFlat);
    if (effRow)  effRow.classList.toggle('highlight', !isFlat);

    toggle('.cp-r-monthly-label-flat',     !isFlat);
    toggle('.cp-r-monthly-label-reducing',  isFlat);
  }

  function updateAmortization() {
    const host = document.getElementById('cp-amort');
    if (!host) return;
    Calc.amortView.renderInline(host, {
      startExpanded: true,
      amount: state.amount,
      rate: state.interestRate,
      years: state.tenure,
      method: state.method,
    });
  }

  function updateReferenceGrid() {
    setVal('.cp-grid-rate-num', fmt.percent(state.interestRate));
    toggle('.cp-grid-method-flat',     state.method !== 'flat');
    toggle('.cp-grid-method-reducing', state.method === 'flat');
    const tbody = document.getElementById('cp-grid-tbody');
    if (!tbody) return;
    tbody.innerHTML = REF_AMOUNTS.map(amt => {
      const isHighRow = amt === state.amount;
      const cells = REF_TENURES.map(t => {
        const monthly = state.method === 'flat'
          ? fin.flatRate(amt, state.interestRate, t).monthlyInstalment
          : fin.reducingRate(amt, state.interestRate, t).monthlyInstalment;
        const isHighCol = t === state.tenure;
        return `<td class="${isHighCol ? 'highlight-col' : ''}">${fmt.number(monthly, 0)}</td>`;
      }).join('');
      return `<tr class="${isHighRow ? 'highlight' : ''}"><th>RM ${amt.toLocaleString()}</th>${cells}</tr>`;
    }).join('');
  }

  function updateBankCards() {
    const wraps = document.querySelectorAll('.bank-card-wrap');
    const emptyState = document.querySelector('#bank-grid .bank-empty-state');
    const isFlat = state.method === 'flat';

    // First pass: filter + compute per eligible card.
    const eligible = [];
    const ineligibleReasons = [];
    wraps.forEach((wrap, i) => {
      // data-rate carries the bank's quoted rate as a percentage (e.g. 5.07).
      // Convert once to decimal for finance + fmt.percent consumption.
      const bankRate = (+wrap.dataset.rate) / 100;
      if (!bankRate) { wrap.classList.add('d-none'); return; }

      // Filter: exclude lenders whose [minAmount, maxAmount] or
      // [minTenure, maxTenure] range doesn't fit the user's inputs. No profile
      // inputs on this calculator, so age/income/employment/DSR rules from
      // Calc.eligibility don't apply. Each failed bound emits a structured
      // reason code; the wording lives in the elig-templates partial
      // (data-elig-tpl-*), rendered via Calc.eligibility.renderReasons.
      const minAmt = +wrap.dataset.minAmount || 0;
      const maxAmt = +wrap.dataset.maxAmount || Infinity;
      const minTen = +wrap.dataset.minTenure || 0;
      const maxTen = +wrap.dataset.tenure    || Infinity;

      const reasons = [];
      if (state.amount < minAmt) reasons.push({ code: 'min_loan', params: { min: minAmt } });
      if (state.amount > maxAmt) reasons.push({ code: 'max_loan', params: { max: maxAmt } });
      if (state.tenure < minTen || state.tenure > maxTen) {
        reasons.push({ code: 'tenure_range', params: { min: minTen, max: maxTen } });
      }
      const isEligible = reasons.length === 0;

      wrap.classList.toggle('d-none', !isEligible);
      if (!isEligible) {
        const name = wrap.querySelector('.bank-logo')?.alt || `#${wrap.dataset.bankId}`;
        const rendered = (typeof Calc.eligibility?.renderReasons === 'function')
          ? Calc.eligibility.renderReasons(reasons)
          : reasons.map(r => r.code);
        ineligibleReasons.push(`<strong>${esc(name)}:</strong> ${esc(rendered.join('; '))}`);
        return;
      }

      // Bank's quoted rate is always flat. Calc uses the user's chosen
      // tenure (already guaranteed within [minTen, maxTen] by the filter).
      const r = fin.flatRate(state.amount, bankRate, state.tenure);

      // Interest text — tracks the calc-method toggle:
      //   flat:     show bank's quoted flat rate
      //   reducing: show the effective reducing-rate equivalent
      const displayRate = isFlat
        ? bankRate
        : fin.solveEffectiveRate(state.amount, r.monthlyInstalment, state.tenure);
      const displayLbl  = isFlat ? 'flat' : 'reducing';

      const rateEl = wrap.querySelector('.bank-rate');
      if (rateEl) rateEl.innerHTML = `${fmt.percent(displayRate)} <span class="fw-normal">${displayLbl}</span>`;

      const tenEl = wrap.querySelector('.bank-tenure');
      if (tenEl) tenEl.textContent = `${state.tenure} year${state.tenure === 1 ? '' : 's'}`;

      const m = wrap.querySelector('.bank-monthly');
      const t = wrap.querySelector('.bank-total');
      if (m) m.textContent = fmt.money(r.monthlyInstalment, 0);
      if (t) t.textContent = fmt.money(r.totalRepayment, 0);

      const apply = wrap.querySelector('.bank-apply');
      const base  = wrap.dataset.applyUrl;
      if (apply && base) {
        try {
          const url = new URL(base);
          url.searchParams.set('amount', state.amount);
          url.searchParams.set('tenure', state.tenure);
          apply.href = url.toString();
        } catch (e) { apply.href = base; }
      }

      eligible.push({
        wrap,
        index: i,
        name: wrap.querySelector('.bank-apply')?.dataset.value || '',
        // Only axes that actually reorder the visible cards (see products.js).
        metrics: { best: r.monthlyInstalment },
      });
    });

    // Second pass: mark the lowest-monthly card as "Best Offer".
    // Badge = best value; order = the user's chosen sort.
    const bestWrap = eligible.length
      ? Calc.products.rank(eligible, 'best', 'asc')[0].wrap
      : null;
    Calc.products.applyOrder(
      wraps,
      Calc.products.rank(eligible, state.sort.key, state.sort.dir),
      bestWrap
    );

    if (emptyState) emptyState.classList.toggle('d-none', eligible.length > 0);

    // "Not eligible for" panel — list each excluded lender and why.
    const note = document.getElementById('cp-ineligible-note');
    const reasonsEl = document.getElementById('cp-ineligible-reasons');
    if (note && reasonsEl) {
      if (ineligibleReasons.length) {
        note.classList.remove('d-none');
        reasonsEl.innerHTML = ineligibleReasons.join('\n');
      } else {
        note.classList.add('d-none');
      }
    }
  }

  function refresh() {
    syncInput('cp-amount-input', state.amount);
    syncInput('cp-rate-input',   (state.interestRate * 100).toFixed(2));
    syncInput('cp-tenure-input', state.tenure);

    // Rate input label + method hint — toggle the HTML-rendered variants.
    const isFlat = state.method === 'flat';
    toggle('.cp-rate-label-flat',     !isFlat);
    toggle('.cp-rate-label-reducing',  isFlat);
    toggle('.cp-method-hint-flat',     !isFlat);
    toggle('.cp-method-hint-reducing',  isFlat);
    document.querySelectorAll('#cp-method-tabs button').forEach(btn => {
      const active = btn.dataset.method === state.method;
      btn.classList.toggle('btn-primary', active);
      btn.classList.toggle('btn-outline-primary', !active);
    });

    updateStatBand();
    updateBankCards();

    if (state.activeTab === 'breakdown') {
      updateBreakdown();
      updateAmortization();
    } else {
      updateReferenceGrid();
    }
  }

  function activateTab(tabId) {
    state.activeTab = tabId;
    document.querySelectorAll('#cp-tabs .btn-tab').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tab === tabId);
    });
    document.querySelectorAll('.tab-panel').forEach(panel => {
      panel.classList.toggle('d-none', panel.id !== `cp-tab-${tabId}`);
    });
    if (tabId === 'breakdown') { updateBreakdown(); updateAmortization(); }
    else { updateReferenceGrid(); }
  }

  function bindEvents() {
    ['input', 'change'].forEach(evt => document.addEventListener(evt, (e) => {
      const id = e.target.id;
      const v = Calc.input.getValue(e.target);
      if (id === 'cp-amount-input') { state.amount = v || 0;                refresh(); }
      if (id === 'cp-rate-input')   { state.interestRate = (v || 0) / 100;  refresh(); }
      if (id === 'cp-tenure-input') { state.tenure = v || 1;                refresh(); }
    }));

    document.querySelectorAll('#cp-tabs .btn-tab').forEach(btn => {
      btn.addEventListener('click', () => activateTab(btn.dataset.tab));
    });

    document.querySelectorAll('#cp-method-tabs button').forEach(btn => {
      btn.addEventListener('click', () => { state.method = btn.dataset.method; refresh(); });
    });

    const initialSort = Calc.products.bindSort('#cp-sort-select', (sort) => {
      state.sort = sort;
      updateBankCards();
    });
    if (initialSort) state.sort = initialSort;
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindEvents();
    refresh();
  });
})();